/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class VariantDrawer extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      container: '.variant-drawer__container',
      summary: '.variant-drawer__summary',
      content: '.variant-drawer__content',
      closeButton: '.variant-drawer__close',
      overlayClass: 'variant-drawer__overlay'
    };
    this.classes = {
      active: 'active',
      overflowHidden: 'overflow-hidden',
      isClosing: 'is-closing'
    };
    this.overlay = null;
    this.handleKey = this.handleKey.bind(this);
    this.handleOverlayClick = this.closeDrawer.bind(this);
  }
  connectedCallback() {
    this.container = this.querySelector(this.selectors.container);
    if (this.container?.tagName === 'DETAILS') {
      const div = document.createElement('div');
      div.className = this.container.className;
      div.innerHTML = this.container.innerHTML;
      this.container.replaceWith(div);
      this.container = div;
    }
    this.summary = this.container.querySelector(this.selectors.summary);
    this.content = this.container.querySelector(this.selectors.content);
    this.closeButton = this.container.querySelector(this.selectors.closeButton);
    this.createOverlay();
    this.bindEvents();
    if (this.summary) {
      this.summary.addEventListener('click', e => {
        e.preventDefault();
        this.openDrawer();
      });
    }
  }
  createOverlay() {
    this.overlay = document.createElement('div');
    this.overlay.className = this.selectors.overlayClass;
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(this.overlay);
  }
  bindEvents() {
    this.overlay?.addEventListener('click', this.handleOverlayClick);
    this.closeButton?.addEventListener('click', () => this.closeDrawer());
    document.addEventListener('keydown', this.handleKey);
  }
  openDrawer() {
    this.classList.add(this.classes.active);
    this.overlay?.classList.add(this.classes.active);
    document.body.classList.add(this.classes.overflowHidden);
  }
  closeDrawer() {
    this.classList.add(this.classes.isClosing);
    this.classList.remove(this.classes.active);
    this.overlay?.classList.remove(this.classes.active);
    document.body.classList.remove(this.classes.overflowHidden);
    setTimeout(() => {
      this.classList.remove(this.classes.isClosing);
    }, 400);
  }
  handleKey(event) {
    if (event.key === 'Escape' && this.classList.contains(this.classes.active)) {
      this.closeDrawer();
    }
  }
  disconnectedCallback() {
    this.overlay?.removeEventListener('click', this.handleOverlayClick);
    this.closeButton?.removeEventListener('click', this.closeDrawer);
    document.removeEventListener('keydown', this.handleKey);
    if (this.overlay?.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
    }
  }
}
if (!customElements.get('variant-drawer')) {
  customElements.define('variant-drawer', VariantDrawer);
}
/******/ })()
;